/**
 * This is a wrapper function over the gettext2 functions.
 */
export default {

    methods: {
        translationGetText (msgId) {
            return this.$gettext(msgId)
        },
        translationGetTextInterpolate (expression, params) {
            return this.$gettextInterpolate(expression, params)
        }
    }

}
